import { useEffect } from 'react';

const tg = typeof window !== 'undefined' ? window.Telegram?.WebApp : undefined;

/**
 * Подписывается на смену темы Telegram и форсит ререндер.
 * Telegram автоматически обновляет CSS-переменные,
 * но некоторые inline-стили могут потребовать ручного обновления.
 */
export function useThemeWatcher() {
  useEffect(() => {
    if (!tg?.onEvent) return;

    const handleThemeChange = () => {
      document.documentElement.style.setProperty('--theme-updated', Date.now().toString());
    };

    tg.onEvent('themeChanged', handleThemeChange);
    return () => tg.offEvent?.('themeChanged', handleThemeChange);
  }, []);
}
